import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Maneja el scroll al navegar. Sin esto pasan dos cosas:
 *
 * 1. Al ir de una página a otra, el browser conserva el scroll anterior y la nueva abre
 *    por la mitad.
 * 2. Los links a anclas de la home (`/#contacto`, `/#servicios`) no hacen nada cuando se
 *    los clickea estando en otra ruta: React Router cambia la URL sin recargar, y el
 *    salto al ancla lo hace el browser solo en una navegación real.
 *
 * El `setTimeout(0)` espera a que React pinte la página nueva: sin eso el elemento del
 * ancla todavía no está en el DOM y `getElementById` devuelve null.
 */
const ScrollManager = () => {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        if (hash) {
            const id = hash.slice(1);
            const t = setTimeout(() => {
                const el = document.getElementById(id);
                if (el) {
                    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                } else {
                    window.scrollTo(0, 0);
                }
            }, 0);
            return () => clearTimeout(t);
        }

        window.scrollTo(0, 0);
    }, [pathname, hash]);

    return null;
};

export default ScrollManager;
